import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return ['portrait', 'landscape'];
  }

  initialize() {
    const styles = getComputedStyle(this.element);
    const aspectRatioBreakpoint = styles.getPropertyValue('--aspect-ratio-breakpoint') || '3/2';
    const mediaQuery = window.matchMedia(`(min-aspect-ratio: ${aspectRatioBreakpoint})`);

    try {
      mediaQuery.addEventListener('change', (e) => this.handleBreakpointChange(e));
    } catch (e1) {
      try {
        mediaQuery.addListener((e) => this.handleBreakpointChange(e));
      } catch (e2) {
        console.error('MediaQuery listener failed', e2);
      }
    }

    this.handleBreakpointChange(mediaQuery);
  }

  handleBreakpointChange(e) {
    const isLandscape = e.matches ?? e.currentTarget?.matches;

    if (!isLandscape && this.hasPortraitTarget) {
      // Portrait view AND portrait video is available
      this.enableVideoSrc(this.portraitTarget);
    } else if (this.hasLandscapeTarget) {
      // Fallback to landscape (default)
      this.enableVideoSrc(this.landscapeTarget);
    } else {
      console.warn('No video targets found');
    }
  }

  enableVideoSrc(target) {
    if (target && !target.src) {
      target.src = target.getAttribute("data-src");
    }
  }
}